import { api } from '../../../AxiosConfig';

class AssinaturasService {
    create(data: any) {
        return api.post('/assinaturas/create', data);
    }

    findAll() {
        return api.get('/assinaturas/findAll');
    }

    getInfoById(id: string) {
        return api.get(`/assinaturas/getInfoById/${id}`);
    }

    listarPorAssinatura(assinaturaId: string) {
        return api.get(`/assinatura-periodo/by-assinatura/${assinaturaId}`);
    }

    update(_id: string, update: any) {
        return api.post('/assinaturas/update', { _id, update });
    }

    delete(_id: string) {
        return api.post('/assinaturas/delete', { _id });
    }
}

class AssinaturaPeriodoService {
    listarPorAssinatura(assinaturaId: string) {
        // estabId vem do token (GetEstabId), não mandar query
        return api.get(`/assinatura-periodo/by-assinatura/${assinaturaId}`);
    }

    getInfoById(id: string) {
        return api.get(`/assinatura-periodo/getInfoById/${id}`);
    }

    listarAgendamentos(periodoId: string) {
        return api.get(`/horarios/assinatura-periodo/${periodoId}`);
    }

    ajustarUso(periodoId: string, serviceId: string, delta: 1 | -1) {
        return api.patch(`/assinatura-periodo/usage/${periodoId}`, { serviceId, delta });
    }

    // 🔧 IMPORTANTE: usar PATCH e o path correto
    atualizarCobranca(
        periodoId: string,
        payload: { valorPago?: number; cobrancaStatus?: string; paidAt?: string | null; paymentMethod?: string }
    ) {
        return api.patch(`/assinatura-periodo/billing/${periodoId}`, payload);
    }

    // (opcional) caso você use o evento de pagamento real:
    aplicarPagamento(payload: {
        assinaturaId: string;
        amount: number;
        periodoId?: string;
        dataReferencia?: string;
        invoiceId?: string;
        paidAt?: string | Date;
    }) {
        return api.post(`/assinatura-periodo/aplicar-pagamento`, payload);
    }
}


export { AssinaturasService, AssinaturaPeriodoService };
